package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

val TopbarStyle = CssStyle {
    base {
        Modifier
            .height(58.px)
            .padding(leftRight = 20.px)
            .position(Position.Sticky)
            .top(0.px)
            .zIndex(100)
    }

    Breakpoint.LG {
        Modifier
            .height(68.px)
            .padding(leftRight = 90.px)
    }
}

val BrandingStyle = CssStyle {
    base {
        Modifier.margin(right = 10.px)
    }

    Breakpoint.LG {
        Modifier.margin(right = 40.px)
    }
}

val ActionButtonsRowStyle = CssStyle {
    base          { Modifier.gap(8.px) }
    Breakpoint.MD { Modifier.gap(12.px) }
}

val DashboardButtonStyle = CssStyle {
    base          { Modifier.width(100.px).height(30.px).fontSize(12.px) }
    Breakpoint.MD { Modifier.width(140.px).height(40.px).fontSize(16.px) }
}

val CreateCvButtonStyle = CssStyle {
    base          { Modifier.width(80.px).height(30.px).fontSize(12.px) }
    Breakpoint.MD { Modifier.width(120.px).height(40.px).fontSize(16.px) }
}

val LoginButtonStyle = CssStyle {
    base          { Modifier.width(80.px).height(30.px).fontSize(12.px) }
    Breakpoint.MD { Modifier.width(120.px).height(40.px).fontSize(16.px) }
}

val DesktopNavContainerStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.None)
    }
    Breakpoint.MD {
        Modifier
            .display(DisplayStyle.Flex)
            .gap(40.px)
    }
}

val CreateCvButtonTextStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val LoginButtonTextStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val ThemeIconStyle = CssStyle {
    base {
        Modifier
            .margin(left = 6.px)
            .fontSize(20.px)
            .cursor(Cursor.Pointer)
    }
    Breakpoint.MD {
        Modifier
            .margin(left = 40.px)
            .fontSize(30.px)
    }
}

val MobileMenuBurgerStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .margin(left = 10.px)
            .cursor(Cursor.Pointer)
            .fontSize(22.px)
    }
    Breakpoint.MD {
        Modifier.display(DisplayStyle.None)
    }
}

val NavLinkStyle = CssStyle {
    base {
        Modifier
            .fontFamily(INTER)
            .textDecorationLine(TextDecorationLine.None)
            .fontSize(16.px)
    }
}

//footer

val FooterMobileContainerStyle = CssStyle {
    base { Modifier.padding(leftRight = 20.px) }
}

val FooterDesktopContainerStyle = CssStyle {
    base { Modifier.padding(leftRight = 40.px) }
}

val FooterLinkGapStyle = CssStyle {
    base          { Modifier.styleModifier { property("gap", "12px") } }
    Breakpoint.MD { Modifier.styleModifier { property("gap", "15px") } }
}

val NavigationLinkStyle = CssStyle {
    base          { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(18.px) }
}
